import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getHeaders as getHeadersSdk,
  getHeader as getHeaderSdk,
  postHeader as postHeaderSdk,
  putHeader as putHeaderSdk,
} from '@sdk/Conectores/Headers';

//Action Types
export const Types = {
  GET_HEADERS: 'GET_HEADERS',
  GET_HEADERS_SUCCESS: 'GET_HEADERS_SUCCESS',
  GET_HEADERS_ERROR: 'GET_HEADERS_ERROR',

  GET_HEADER: 'GET_HEADER',
  GET_HEADER_SUCCESS: 'GET_HEADER_SUCCESS',
  GET_HEADER_ERROR: 'GET_HEADER_ERROR',

  POST_HEADER: 'POST_HEADER',
  POST_HEADER_SUCCESS: 'POST_HEADER_SUCCESS',
  POST_HEADER_ERROR: 'POST_HEADER_ERROR',

  PUT_HEADER: 'PUT_HEADER',
  PUT_HEADER_SUCCESS: 'PUT_HEADER_SUCCESS',
  PUT_HEADER_ERROR: 'PUT_HEADER_ERROR',

  RESET_HEADERS: 'RESET_HEADERS',
};

//Action Creators
export const getHeaders = (idConfiguracao) => ({ type: Types.GET_HEADERS, idConfiguracao });
export const getHeadersSuccess = (data) => ({ type: Types.GET_HEADERS_SUCCESS, data });
export const getHeadersError = (error) => ({ type: Types.GET_HEADERS_ERROR, error });

export const getHeader = (idConfiguracao, id) => ({ type: Types.GET_HEADER, idConfiguracao, id });
export const getHeaderSuccess = (data) => ({ type: Types.GET_HEADER_SUCCESS, data });
export const getHeaderError = (error) => ({ type: Types.GET_HEADER_ERROR, error });

export const postHeader = (data) => ({ type: Types.POST_HEADER, data });
export const postHeaderSuccess = () => ({ type: Types.POST_HEADER_SUCCESS });
export const postHeaderError = (error) => ({ type: Types.POST_HEADER_ERROR, error });

export const putHeader = (data) => ({ type: Types.PUT_HEADER, data });
export const putHeaderSuccess = () => ({ type: Types.PUT_HEADER_SUCCESS });
export const putHeaderError = (error) => ({ type: Types.PUT_HEADER_ERROR, error });

export const reset = () => ({ type: Types.RESET_HEADERS });

//saga
function* fetchGetHeaders(action) {
  try {
    const { idConfiguracao } = action;
    const headers = yield call(getHeadersSdk, idConfiguracao);
    yield put(getHeadersSuccess(headers));
  } catch (err) {
    Notification.error(err.message);
    yield put(getHeadersError(err));
  }
}
function* fetchGetHeader(action) {
  try {
    const { idConfiguracao, id } = action;
    const header = yield call(getHeaderSdk, idConfiguracao, id);
    yield put(getHeaderSuccess(header));
  } catch (err) {
    Notification.error(err.message);
    yield put(getHeaderError(err));
  }
}

function* fetchPostHeader(action) {
  try {
    const { data } = action;
    yield call(postHeaderSdk, data);
    yield put(postHeaderSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(postHeaderError(err));
  }
}

function* fetchPutHeader(action) {
  try {
    const { data } = action;
    yield call(putHeaderSdk, data);
    yield put(putHeaderSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(putHeaderError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_HEADERS, fetchGetHeaders),
  takeLatest(Types.GET_HEADER, fetchGetHeader),
  takeLatest(Types.POST_HEADER, fetchPostHeader),
  takeLatest(Types.PUT_HEADER, fetchPutHeader),
];

// Reducer
const initialState = Map({
  headers: List(),
  header: {},

  loadingHeaders: false,
  successHeaders: false,
  errorHeaders: false,

  loadingHeader: false,
  successHeader: false,
  errorHeader: false,

  postingHeader: false,
  successPostHeader: false,
  errorPostHeader: false,

  putingHeader: false,
  successPutHeader: false,
  errorPutHeader: false,
});

const handleGetHeaders = (state, action) => {
  return state.set('loadingHeaders', true).set('successHeaders', false).set('errorHeaders', false);
};

const handleGetHeadersSuccess = (state, action) => {
  const headers = action.data;

  return state.set('headers', List(headers)).set('loadingHeaders', false).set('successHeaders', true).set('errorHeaders', false);
};

const handleGetHeadersError = (state, action) => {
  return state.set('loadingHeaders', false).set('successHeaders', false).set('errorHeaders', action.error);
};

const handleGetHeader = (state, action) => {
  return state.set('loadingHeader', true).set('successHeader', false).set('errorHeader', false);
};

const handleGetHeaderSuccess = (state, action) => {
  const header = action.data[0];
  return state.set('header', header).set('loadingHeader', false).set('successHeader', true).set('errorHeader', false);
};

const handleGetHeaderError = (state, action) => {
  return state.set('loadingHeader', false).set('successHeader', false).set('errorHeader', action.error);
};

const handlePostHeader = (state, action) => {
  return state.set('postingHeader', true).set('successPostHeader', false).set('errorPostHeader', false);
};

const handlePostHeaderSuccess = (state, action) => {
  return state.set('postingHeader', false).set('successPostHeader', true).set('errorPostHeader', false);
};

const handlePostHeaderError = (state, action) => {
  return state.set('postingHeader', false).set('successPostHeader', false).set('errorPostHeader', action.error);
};

const handlePutHeader = (state, action) => {
  return state.set('putingHeader', true).set('successPutHeader', false).set('errorPutHeader', false);
};

const handlePutHeaderSuccess = (state, action) => {
  return state.set('putingHeader', false).set('successPutHeader', true).set('errorPutHeader', false);
};

const handlePutHeaderError = (state, action) => {
  return state.set('putingHeader', false).set('successPutHeader', false).set('errorPutHeader', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_HEADERS:
      return handleGetHeaders(state, action);
    case Types.GET_HEADERS_SUCCESS:
      return handleGetHeadersSuccess(state, action);
    case Types.GET_HEADERS_ERROR:
      return handleGetHeadersError(state, action);

    case Types.GET_HEADER:
      return handleGetHeader(state, action);
    case Types.GET_HEADER_SUCCESS:
      return handleGetHeaderSuccess(state, action);
    case Types.GET_HEADER_ERROR:
      return handleGetHeaderError(state, action);

    case Types.POST_HEADER:
      return handlePostHeader(state, action);
    case Types.POST_HEADER_SUCCESS:
      return handlePostHeaderSuccess(state, action);
    case Types.POST_HEADER_ERROR:
      return handlePostHeaderError(state, action);

    case Types.PUT_HEADER:
      return handlePutHeader(state, action);
    case Types.PUT_HEADER_SUCCESS:
      return handlePutHeaderSuccess(state, action);
    case Types.PUT_HEADER_ERROR:
      return handlePutHeaderError(state, action);

    case Types.RESET_HEADERS:
      return handleReset(state, action);

    default:
      return state;
  }
}
